import { Button, ModalDialog, ModalOverlay } from '@flos/react-ui';
import { useState } from 'react';
import CallMeModal from '../CallMeModal/CallMeModal';
import { useHippoText } from '../../hooks/useHippoText';
import { useRecoilValue } from 'recoil';
import { isLoggedOnSelector } from '../../recoil/selectors/isLoggedOnSelector';

const ErrorModal = ({ retry, error }: { retry?: () => void; error?: Error }): React.JSX.Element => {
    const getHippoText = useHippoText();
    const [openErrorModal, setOpenErrorModal] = useState(true);
    const closeModal = (): void => {
        window.location.href = '/';
    };
    const activityCode = 'dss_unexpected_error_phone_req';
    const isLoggedOn = useRecoilValue(isLoggedOnSelector);

    return (
        <div id="error-modal">
            <ModalOverlay isOpen={openErrorModal} id="modal-dialog">
                <ModalDialog closeIconHandler={closeModal}>
                    <div className="u-spacing-inset-l">
                        <div className="u-spacing-inset-l--stretch-max">
                            <h4 className="u-spacing-stack-sm">
                                {getHippoText('DSS-UNEXPECTED-ERROR-MODAL-HEADER')}
                            </h4>
                            <p className="u-spacing-stack-none">
                                {isLoggedOn
                                    ? getHippoText('DSS-UNEXPECTED-ERROR-MODAL-SUBHEADER')
                                    : getHippoText(
                                          'DSS-UNEXPECTED-ERROR-MODAL-UNIDENTIFIED-CUSTOMER-SUBHEADER'
                                      )}
                            </p>
                        </div>
                        <Button onClick={retry} id="error-retry-button">
                            Prøv igen
                        </Button>
                        <Button
                            theme={'secondary'}
                            onClick={() => {
                                setOpenErrorModal(false);
                            }}
                            id="error-callme-button"
                        >
                            Ring mig op
                        </Button>
                    </div>
                </ModalDialog>
            </ModalOverlay>
            <CallMeModal
                activityCode={activityCode}
                showModal={!openErrorModal}
                closeModal={closeModal}
                setOpenErrorModal={setOpenErrorModal}
                error={error}
            />
        </div>
    );
};

export default ErrorModal;
